import React from "react";
import { Form } from "react-bootstrap";
import { VehicleTypeModel, getVehicleTypeString } from "../api/vehicleFileAPI";

export interface VehicleFileDetails {
  description?: string;
  type?: VehicleTypeModel;
}

interface VehicleFileDetailsFormProps {
  details: VehicleFileDetails;
  onChange: (details: VehicleFileDetails) => void;
}

function VehicleFileDetailsForm({
  details,
  onChange,
}: VehicleFileDetailsFormProps) {
  const descriptionChanged = (description: string) => {
    if (description !== details.description) {
      onChange({ ...details, ...{ description: description } });
    }
  };

  const typeChanged = (type: VehicleTypeModel) => {
    if (type !== details.type) {
      onChange({ ...details, ...{ type: type } });
    }
  };

  return (
    <>
      <Form.Group className="mb-3">
        <Form.Label>Description</Form.Label>
        <Form.Control
          type="text"
          defaultValue={details.description}
          placeholder="description for the vehicle file"
          autoFocus
          onChange={(e) => descriptionChanged(e.target.value)}
        />
        <Form.Text>
          Fill the "description" with the following items: Modelname, Body
          Style, (Extra modelinfo), Modelcode, Start year – Year end
        </Form.Text>
      </Form.Group>

      <Form.Group className="mb-3">
        <Form.Label>Vehicle Type</Form.Label>
        <Form.Select
          defaultValue={details.type}
          onChange={(e) => typeChanged(Number(e.target.value))}
        >
          {(details.type ?? 0) <= 0 && (
            <option key="0" value="">
              [select]
            </option>
          )}
          {Object.keys(VehicleTypeModel)
            .filter((key) => !isNaN(Number(key)))
            .map((key) => (
              <option key={key} value={Number(key)}>
                {getVehicleTypeString(Number(key))}
              </option>
            ))}
        </Form.Select>
      </Form.Group>
    </>
  );
}

export default VehicleFileDetailsForm;
